export default "__VITE_ASSET__CQ56vyaR__"